<template>
  <div class="home">
    <bookings />
  </div>
</template>

<script>
import Bookings from "../components/views/Bookings";

export default {
  name: 'home',
  components: {Bookings},
  async mounted() {
    await this.$store.dispatch('bookings/setBookings', {day: this.$moment().startOf('isoWeek').toDate(), isWeek: true});
    await this.$store.dispatch('estimates/setEstimates');
    await this.$store.dispatch('estimates/setDrafts');
    await this.$store.dispatch('customers/setCustomers');
    await this.$store.dispatch('parts/setParts');
    await this.$store.dispatch('admin/setEvents');
    await this.$store.dispatch('admin/setNotes');
  }
}
</script>
